import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../constants/api.endpoints';

export interface SupportUserRecord {
  id: string;
  fullName: string;
  email: string;
  phoneNumber?: string;
  verified: boolean;
  createdAt?: string;
}

export interface SupportUserCreateRequest {
  fullName: string;
  email: string;
  password: string;
  phoneNumber?: string;
  gender?: string;
  selectedCountry?: string;
  selectedState?: string;
  selectedCity?: string;
  address1?: string;
  address2?: string;
  zipCode?: string;
}

export interface SupportPermissionsUpdateRequest {
  permissionCodes: string[];
}

export interface SupportAccessResponse {
  role: string;
  roleId?: string;
  permissionCodes: string[];
  superAdminRoleId?: string;
  superAdminPermissionCodes: string[];
}

export interface RmaApiResponse<T> {
  successful: boolean;
  message: string;
  response: T;
  errors?: string[] | null;
  statusCode?: number;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SupportManagementService {
  private readonly http = inject(HttpClient);
  private readonly usersBaseUrl = `${ApiEndpoints.BASE_URL}${ApiEndpoints.Users}`;

  getSupportUsers(): Observable<RmaApiResponse<SupportUserRecord[]>> {
    return this.http.get<RmaApiResponse<SupportUserRecord[]>>(`${this.usersBaseUrl}/support`);
  }

  createSupportUser(payload: SupportUserCreateRequest): Observable<RmaApiResponse<SupportUserRecord>> {
    return this.http.post<RmaApiResponse<SupportUserRecord>>(`${this.usersBaseUrl}/support`, payload);
  }

  getSupportAccess(): Observable<RmaApiResponse<SupportAccessResponse>> {
    return this.http.get<RmaApiResponse<SupportAccessResponse>>(`${this.usersBaseUrl}/support/access`);
  }

  updateSupportAccess(
    payload: SupportPermissionsUpdateRequest
  ): Observable<RmaApiResponse<{ role: string; roleId?: string; assignedPermissionCodes: string[]; assignedPermissionCount: number }>> {
    return this.http.put<RmaApiResponse<{ role: string; roleId?: string; assignedPermissionCodes: string[]; assignedPermissionCount: number }>>(
      `${this.usersBaseUrl}/support/access`,
      payload
    );
  }
}
